import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbAlertModule, NgbDatepickerModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
// Components
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { FeatherIconsComponent } from "./components/feather-icons/feather-icons.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { ContentComponent } from "./components/layout/content/content.component";
import { FullComponent } from "./components/layout/full/full.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { TapToTopComponent } from "./components/tap-to-top/tap-to-top.component";
// Header Elements Components
import { SearchComponent } from "./components/header/elements/search/search.component";
import { LanguagesComponent } from "./components/header/elements/languages/languages.component";
import { NotificationComponent } from "./components/header/elements/notification/notification.component";
import { BookmarkComponent } from "./components/header/elements/bookmark/bookmark.component";
import { CartComponent } from "./components/header/elements/cart/cart.component";
import { MessageBoxComponent } from "./components/header/elements/message-box/message-box.component";
import { MyAccountComponent } from "./components/header/elements/my-account/my-account.component";

// Services
import { LayoutService } from "./services/layout.service";
import { NavService } from "./services/nav.service";
import { DecimalPipe } from "@angular/common";
import { SvgIconComponent } from "./components/svg-icon/svg-icon.component";
import { SwiperModule } from "swiper/angular";
import { SwiperComponent } from "./components/header/elements/swiper/swiper.component";
import { ButtonComponent } from './common-components/button/button.component';
import { CheckboxComponent } from './common-components/checkbox/checkbox.component';
import { SearchInputComponent } from './common-components/search-input/search-input.component';
import { InputComponent } from './common-components/input/input.component';
import { DatePickerComponent } from './common-components/date-picker/date-picker.component';
import { RangeDatePickerComponent } from './common-components/range-date-picker/range-date-picker.component';
import { TextAreaComponent } from './common-components/text-area/text-area.component';
import { SelectDropdownComponent } from './common-components/select-dropdown/select-dropdown.component';
import { PlusIconComponent } from './common-components/ag-grid/plus-icon/plus-icon.component';
import { ResetDeleteIconComponent } from './common-components/ag-grid/reset-delete-icon/reset-delete-icon.component';
import { AgGridComponent } from './common-components/ag-grid/ag-grid.component';
import { AgGridModule } from "ag-grid-angular";
import { ButtonCellrendererComponent } from './common-components/ag-grid/button-cellrenderer/button-cellrenderer.component';
import { TextSvgCellrenderComponent } from './common-components/ag-grid/text-svg-cellrender/text-svg-cellrender.component';
import { CheckboxCellrenderComponent } from './common-components/ag-grid/checkbox-cellrender/checkbox-cellrender.component';
import { AppDropdownComponent } from './common-components/app-dropdown/app-dropdown.component';
import { EnumToListPipe } from './pipes/enum-to-list.pipe';
import { ImageRendererComponent } from './common-components/ag-grid/image-renderer/image-renderer.component';
import { TextRendererComponent } from './common-components/ag-grid/text-renderer/text-renderer.component';
import { TransactionHistoryComponent } from "../components/subscription/customer-details/transaction-history/transaction-history.component";
import { LazySrcDirective } from './directives/lazy-src.directive';
import { AgGridCustomDropdownComponent } from './common-components/ag-grid/ag-grid-custom-dropdown/ag-grid-custom-dropdown.component';
import { InputDatepickerRendererComponent } from './common-components/ag-grid/input-datepicker-renderer/input-datepicker-renderer.component';
import { CustomHeaderComponent } from "./common-components/ag-grid/custom-header/custom-header.component";
import { EmailIconRendererComponent } from './common-components/ag-grid/email-icon-renderer/email-icon-renderer.component';
import { WhatsappIconRendererComponent } from './common-components/ag-grid/whatsapp-icon-renderer/whatsapp-icon-renderer.component';
import { CustomExpandableComponent } from './common-components/ag-grid/custom-expandable/custom-expandable.component';
import { CommonPopupComponent } from './common-popup/common-popup.component';
import { AgGridCustomInputComponent } from './common-components/ag-grid/ag-grid-custom-input/ag-grid-custom-input.component';
import { PdfIconRendererComponent } from './common-components/ag-grid/pdf-icon-renderer/pdf-icon-renderer.component';
import { AgGridCustomSearchDropdownComponent } from './common-components/ag-grid/ag-grid-custom-search-dropdown/ag-grid-custom-search-dropdown.component';
import { NgMultiSelectDropdownComponent } from './common-components/ng-multi-select-dropdown/ng-multi-select-dropdown.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgApexchartsModule } from "ng-apexcharts";
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NumericEditorComponent } from './common-components/ag-grid/numeric-editor/numeric-editor.component';
import { OtpVerificationComponent } from './common-components/otp-verification/otp-verification.component';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { GoogleMapsModule } from '@angular/google-maps';
import { CommonIconsComponent } from './common-components/ag-grid/common-icons/common-icons.component';
import { PasswordVerificationComponent } from './common-components/password-verification/password-verification.component';
import { CustomerDetailsComponent } from "../components/subscription/customer-details/customer-details.component";
import { BusinessDetailsComponent } from "../components/subscription/customer-details/business-details/business-details.component";
import { AddressComponent } from "../components/subscription/customer-details/address/address.component";
import { BankDetailsComponent } from "../components/subscription/customer-details/bank-details/bank-details.component";
import { CurrentPlanComponent } from "../components/subscription/customer-details/current-plan/current-plan.component";
@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ContentComponent,
    BreadcrumbComponent,
    FeatherIconsComponent,
    FullComponent,
    LoaderComponent,
    TapToTopComponent,
    SearchComponent,
    LanguagesComponent,
    NotificationComponent,
    BookmarkComponent,
    CartComponent,
    MessageBoxComponent,
    MyAccountComponent,
    SvgIconComponent,
    SwiperComponent,
    ButtonComponent,
    CheckboxComponent,
    SearchInputComponent,
    InputComponent,
    DatePickerComponent,
    RangeDatePickerComponent,
    TextAreaComponent,
    SelectDropdownComponent,
    PlusIconComponent,
    ResetDeleteIconComponent,
    AgGridComponent,
    ButtonCellrendererComponent,
    TextSvgCellrenderComponent,
    CheckboxCellrenderComponent,
    AppDropdownComponent,
    EnumToListPipe,
    ImageRendererComponent,
    TextRendererComponent,
    TransactionHistoryComponent,
    LazySrcDirective,
    AgGridCustomDropdownComponent,
    InputDatepickerRendererComponent,
    CustomHeaderComponent,
    EmailIconRendererComponent,
    WhatsappIconRendererComponent,
    CustomExpandableComponent,
    CommonPopupComponent,
    AgGridCustomInputComponent,
    PdfIconRendererComponent,
    AgGridCustomSearchDropdownComponent,
    NgMultiSelectDropdownComponent,
    NumericEditorComponent,
    OtpVerificationComponent,
    OnlyNumbersDirective,
    CommonIconsComponent,
    PasswordVerificationComponent,
    CustomerDetailsComponent,
    BusinessDetailsComponent,
    AddressComponent,
    BankDetailsComponent,
    CurrentPlanComponent,
  ],
  imports: [CommonModule, RouterModule,NgApexchartsModule, FormsModule, ReactiveFormsModule, NgbModule, SwiperModule,AgGridModule,NgbDatepickerModule, NgbAlertModule,
    NgMultiSelectDropDownModule.forRoot(),NgxDropzoneModule,GoogleMapsModule
  ],
  providers: [NavService, LayoutService, DecimalPipe],
  exports: [NgbModule, FormsModule, ReactiveFormsModule, LoaderComponent, BreadcrumbComponent, FeatherIconsComponent, TapToTopComponent, SvgIconComponent, SwiperModule,
            ButtonComponent,
            CheckboxComponent,
            SearchInputComponent,
            InputComponent,
            NgApexchartsModule,
            DatePickerComponent,
            RangeDatePickerComponent,
            TextAreaComponent,
            TransactionHistoryComponent,GoogleMapsModule,OnlyNumbersDirective,
            SelectDropdownComponent,PlusIconComponent,ResetDeleteIconComponent,AgGridComponent,TextRendererComponent,NumericEditorComponent,    CustomerDetailsComponent,
    BusinessDetailsComponent,
    AddressComponent,
    BankDetailsComponent,
    CurrentPlanComponent,
          NgbDatepickerModule, NgbAlertModule,AppDropdownComponent,EnumToListPipe,LazySrcDirective,NgMultiSelectDropdownComponent,NgxDropzoneModule],
            
})
export class SharedModule {}
